import React from "react";
import { PtContext } from "./ptProvider";

export default function withContext(Component) {
  return function contextComponent(props) {
    return (
      <PtContext.Consumer>
        {context => <Component {...props} context={context} />}
      </PtContext.Consumer>
    );
  };
}
